<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'freight.assign_driver_vehicles' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form [formGroup]="assignationForm">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-padding-bottom">
        <ion-col>
          <div class="freight-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/barcode_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">{{ 'freight.detail.okcargo_reference' | translate }}</p>
              <p class="ion-no-margin">{{ freight.reference }}</p>
            </div>
          </div>

          <lib-freight-carrier-inprogress-card-basic
            [freight]="freight"
            [hideColumns]="false"
          ></lib-freight-carrier-inprogress-card-basic>

          <p class="fs-sm">
            {{ (canAssignDriver() ? 'freight.assign_help' : 'freight.assign_help_vehicles_only') | translate }}
          </p>

          <ion-grid class="ion-no-padding">
            @if (canAssignDriver()) {
              <ion-row>
                <ion-col class="ion-padding-bottom">
                  <ion-select
                    label="{{ 'users.driver' | translate }}"
                    interface="popover"
                    label-placement="floating"
                    fill="outline"
                    mode="md"
                    multiple="false"
                    formControlName="driver"
                    helperText="{{ 'freight.select_driver' | translate }}"
                    (ionChange)="onDriverChange($event.detail.value)"
                  >
                    <ion-select-option [value]="noSelection">{{ 'general.unselected' | translate }}</ion-select-option>
                    @for (driver of drivers(); track driver.id) {
                      <ion-select-option [value]="driver">{{ driver.label }}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col
                class="ion-padding-bottom okc-gap-md-end"
                size="12"
                [sizeMd]="6"
              >
                <ion-select
                  label="{{ 'vehicles.tractor' | translate }}"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  formControlName="tractor"
                  helperText="{{ 'freight.select_tractor' | translate }}"
                  (ionChange)="onTractorChange($event.detail.value)"
                >
                  <ion-select-option [value]="noSelection">{{ 'general.unselected' | translate }}</ion-select-option>
                  @for (tractor of tractors(); track tractor.id) {
                    <ion-select-option [value]="tractor">{{ tractor.label }}</ion-select-option>
                  }
                </ion-select>
              </ion-col>
              <ion-col
                class="ion-padding-bottom okc-gap-md-start"
                size="12"
                [sizeMd]="6"
              >
                <ion-select
                  label="{{ 'vehicles.trailer' | translate }}"
                  interface="popover"
                  label-placement="floating"
                  fill="outline"
                  mode="md"
                  multiple="false"
                  formControlName="trailer"
                  helperText="{{ 'freight.select_trailer' | translate }}"
                  (ionChange)="onTrailerChange($event.detail.value)"
                >
                  <ion-select-option [value]="noSelection">{{ 'general.unselected' | translate }}</ion-select-option>
                  @for (trailer of trailers(); track trailer.id) {
                    <ion-select-option [value]="trailer">{{ trailer.label }}</ion-select-option>
                  }
                </ion-select>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'general.save' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
